<template>
  <v-col cols="3 position-relative">
    <div class="custom-control custom-checkbox">
      <input type="checkbox" :checked="isSelected" class="custom-control-input mr-1" :id="'checkDoc_' + file.id" @change="toggleSelection" />
      <label class="custom-control-label" :for="'checkDoc_' + file.id"></label>
    </div>
    <v-card class="library-card" @click="openPreview">
      <div class="secondary card-preview d-flex align-center justify-center">
        <div class="card-preview-content d-flex align-center justify-center">
          <h1 class="grey--text mb-0">.{{file.extension}}</h1>
        </div>
      </div>
      <v-card-text class="card-details d-flex flex-column justify-center">
        <h5 class="mb-0" style="flex: 1 1 auto;">
          <b>{{truncateName(file.name)}}</b>
        </h5>
        <span v-if="hasCases" style="flex: 1 1 auto;">{{ displayCaseNames }}</span>
        <span v-else style="flex: 1 1 auto;"><i>No assigned case</i></span>
        <span style="flex: 1 1 auto;">{{prettyDate(file.created_at)}}</span>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: [ "file", "isSelected" ],
  computed: {
    displayCaseNames() {
      if (this.file.case_name) {
        return this.file.case_name;
      } else if (this.file.cases && Array.isArray(this.file.cases)) {
        return this.file.cases.map(caseItem => caseItem.name).join(', ');
      }
      return '';
    },
    hasCases() {
      return this.file.case_name || (this.file.cases && this.file.cases.length > 0);
    },
  },
  methods: {
    prettyDate(date) {
      return moment(date, 'YYYY-MM-DDTHH:mm:SSSZZ').format('MMM D, YYYY')
    },
    openPreview() {
      this.$store.commit("changeEditedDocument", this.file);
      this.$store.commit("toggleShowLightbox", true);
    },
    truncateName(input) {
      if (input && input.length > 22) {
        return input.substring(0,22) + '...'
      } else {
        return input
      }
    },
    toggleSelection() {
      this.$emit("toggle-selection", this.file.id, !this.isSelected);
    }
  }
}
</script>

<style lang="scss" scoped>
.library-card {
  height: 250px;
  .card-preview {
    background-color: #ececec;
    height: 60%;
    .card-preview-content {
      overflow: hidden;
      height: 100%;
    }
  }
  .card-details {
    height: 40%;
  }
}
.hover {
  cursor: pointer;
}

.custom-control {
  position: absolute;
  top: 16px; 
  right: 12px;
  z-index: 99;
}
</style>
